import nxModule from 'nxModule';
import templateUrl from './atm-batch-acquirers.template.html';
import './atm-batch-acquirers-upload.style.less';

nxModule.component('atmBatchAcquirers', {
  templateUrl
});